import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft, User, Clock } from 'lucide-react';
import { API } from '@/App';

const ImpersonationAuditPage = () => {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('token');
  const currentUser = JSON.parse(localStorage.getItem('user') || 'null');

  useEffect(() => {
    if (!currentUser?.is_support && currentUser?.role !== 'super_admin') {
      navigate('/');
      return;
    }
    axios.get(`${API}/support/impersonation-audit?limit=500`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => setLogs(r.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#35AFE4]" />
    </div>
  );

  return (
    <div className="min-h-screen bg-gray-50" data-testid="impersonation-audit-page">
      <div className="max-w-5xl mx-auto p-4 sm:p-6 lg:p-8">
        <button onClick={() => navigate('/support-tech')}
          className="inline-flex items-center gap-1.5 text-sm text-gray-500 hover:text-[#1e3a5f] mb-4">
          <ArrowLeft size={14} /> Retour Support Tech
        </button>

        <div className="flex items-start gap-3 mb-6">
          <div className="w-12 h-12 rounded-2xl bg-[#35AFE4]/15 flex items-center justify-center flex-shrink-0">
            <Shield size={22} className="text-[#1e3a5f]" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-[#1e3a5f]" style={{ fontFamily: "'Barlow', sans-serif" }}>
              Audit d'impersonation
            </h1>
            <p className="text-sm text-gray-500 mt-1">
              Historique de toutes les connexions support en tant qu'un autre utilisateur. Conforme RGPD.
            </p>
          </div>
        </div>

        {logs.length === 0 ? (
          <div className="bg-white rounded-2xl border border-gray-100 p-8 text-center text-gray-400 text-sm">
            Aucune action d'impersonation enregistrée.
          </div>
        ) : (
          <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50 border-b border-gray-100">
                <tr className="text-[10px] text-gray-400 uppercase tracking-wider">
                  <th className="text-left px-4 py-3 font-semibold">Date</th>
                  <th className="text-left px-4 py-3 font-semibold">Support technique</th>
                  <th className="text-left px-4 py-3 font-semibold">Compte cible</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={log.id} className="border-b border-gray-50" data-testid={`audit-row-${log.id}`}>
                    <td className="px-4 py-3 text-gray-500 text-xs whitespace-nowrap">
                      <div className="flex items-center gap-1.5">
                        <Clock size={11} />
                        {new Date(log.created_at).toLocaleString('fr-FR', { dateStyle: 'short', timeStyle: 'short' })}
                      </div>
                    </td>
                    <td className="px-4 py-3">
                      <div className="flex items-center gap-2">
                        <User size={13} className="text-[#35AFE4]" />
                        <span className="font-semibold text-[#1e3a5f]">{log.user_name}</span>
                        <span className="text-[10px] px-1.5 py-0.5 rounded bg-orange-100 text-orange-600 font-bold">{log.user_role}</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-gray-700">{log.entity_name}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="px-4 py-3 bg-gray-50 border-t border-gray-100 text-[11px] text-gray-400">
              {logs.length} entrée{logs.length > 1 ? 's' : ''} affichée{logs.length > 1 ? 's' : ''} (limite 500)
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ImpersonationAuditPage;
